export const BATCH_REPORTS_INTERVAL_SECS = 5;
export const MAX_BATCH = 25;
export const REPORTING_EVENT_TYPE = 'EVENT_TYPE_TRACK';
export const sendImmediatelyEventsMap = {
    APP_SESSION_STARTED: true,
    SANDBOX_EVENT: true,
    DISCORD_OAUTH_ACCEPTED: true,
    DISCORD_OAUTH_DENIED: true,
    DISCORD_ACTIVITY_INITIATED: true,
    DISCORD_ACTIVITY_ENDED: true,
    DISCORD_HOST_ASSIGNED: true,
    DISCORD_SHARED_MODE_ACTIVATED: true,
    DISCORD_SHARED_MODE_DEACTIVATED: true,
    DISCORD_USER_JOINED: true,
    DISCORD_USER_LEFT: true,
    DISCORD_MAX_PARTICIPANTS_REACHED: true,
};
